<template>
  <div :class="classes" style="display: inline-block;">
    <slot>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

const b = (block) => {
  return `v-col-${block}` 
}

export default defineComponent({
  name: "Col",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    span: {
      type: Number,
      default: 24
    },
    offset: {
      type: Number,
      default: 0
    },
    pull: {
      type: Number,
      default: 0
    },
    push: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const classes = computed(() => {
      const classes2 = [];
      const pos = ["span", "offset", "pull", "push"];
      pos.forEach((prop) => {
        const size = props[prop];
        if (!isNaN(size)) {
          if (prop === "span")
            classes2.push(b(`${props[prop]}`));
          else if (size > 0)
            classes2.push(b(`${prop}-${props[prop]}`));
        }
      });
      return classes2;
    }); 

    return {
      classes
    }
  }
});
</script>
